export default {
  // 销售单列表查询
  poc_order_qrySalOrderList: {
    // mock: true,
    control: '/dyc/self/order/qrySalOrderList'
  },
  // 销售单详情查询
  poc_order_qrySalOrderDetail: {
    // mock: true,
    control: '/dyc/self/order/qrySalOrderDetail'
  },
  // 销售单订单审批
  poc_dealOrderAudit: {
    // mock: true,
    control: '/dyc/self/order/dealOrderAudit'
  },
  // 账期支付
  poc_order_paymentDaysPay: {
    // mock: true,
    control: '/dyc/self/order/paymentDaysPay'
  },
  // 取消订单
  poc_order_cancelSalOrder: {
    // mock: true,
    control: '/dyc/self/order/cancelSalOrder'
  },
  // 供应商确认
  poc_order_supplierConfirm: {
    // mock: true,
    control: '/dyc/self/order/supplierConfirm'
  },
  // 到货确认
  poc_order_arrivalCommodityConfirm: {
    // mock: true,
    control: '/dyc/self/order/arrivalCommodityConfirm'
  },
  // 用于发货单列表查询
  poc_order_qryDeliveryOrderList: {
    // mock: true,
    control: '/dyc/self/order/qryDeliveryOrderList'
  },
  // 用于页签环节查询
  poc_order_qryTabTacheCodeList: {
    // mock: true,
    control: '/dyc/self/order/qryTabTacheCodeList'
  },
  // 用于验收单列表查询
  poc_order_qryAcceptOrderList: {
    // mock: true,
    control: '/dyc/self/order/qryAcceptOrderList'
  },
  // 用于取消申请
  poc_order_applyCancel: {
    // mock: true,
    control: '/dyc/self/order/applyCancel'
  },
  // 验收
  poc_order_acceptanceDeliveryOrder: {
    // mock: true,
    control: '/dyc/self/order/acceptanceDeliveryOrder'
  },
  // 用于发货确认
  poc_order_deliverCommodity: {
    // mock: true,
    control: '/dyc/self/order/deliverCommodity'
  },
  // 用于到货登记
  poc_order_arrivalCommodityRegister: {
    // mock: true,
    control: '/dyc/self/order/arrivalCommodityRegister'
  },
  // 用于执行单详情查询
  poc_order_queryImplOrderDetail: {
    // mock: true,
    control: '/dyc/self/order/queryImplOrderDetail'
  },
  // 用于取消申请撤销
  poc_order_dealCancelApplyCancel: {
    // mock: true,
    control: '/dyc/self/order/dealCancelApplyCancel'
  },
  // 用于取消申请列表
  poc_qryMyCancelApplyOrderList: {
    // mock: true,
    control: '/dyc/self/order/qryMyCancelApplyOrderList'
  },
  // 用于取消申请详情
  poc_qryCancelApplyDetail: {
    // mock: true,
    control: '/dyc/self/order/qryCancelApplyDetail'
  },
  // 用于异常单列表查询
  poc_qryExceptionChangesList: {
    // mock: true,
    control: '/dyc/self/order/qryExceptionChangesList'
  },
  // 用于取消申请确认
  poc_confirmCancelApply: {
    // mock: true,
    control: '/dyc/self/order/confirmCancelApply'
  },
  // 订单待办事项列表
  poc_qryListTodo: {
    // mock: true,
    control: '/dyc/self/order/qryListTodo'
  },
  // 订单待办事项列表 - 处理
  poc_dealTodo: {
    // mock: true,
    control: '/dyc/self/order/dealTodo'
  },
  // 机构用户管理-个人用户管理列表
  poc_qryPersonMerchantUserListPage: {
    // mock: true,
    control: 'dyc/saas/common/user/qryPersonMerchantUserListPage'
  },
  // 机构用户管理-个人用户管理-重置密码
  poc_resetPsw: {
    // mock: true,
    control: 'dyc/saas/common/user/resetPsw'
  },
  // 机构用户管理-个人用户管理-停用/启用
  poc_operMember: {
    // mock: true,
    control: 'dyc/saas/common/user/operMember'
  }
};